import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/Login/LoginPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import NotFoundPage from './pages/NotFoundPage';
import { AuthProvider } from './auth/AuthContext';
import PrivateRoute from './auth/PrivateRoute';
import GlobalLoading from './components/GlobalLoading';
import SubscriptionResultPage from './pages/SubscriptionResultPage';
import SubscriptionManagementPage from './pages/SubscriptionManagementPage';


const AppRoutes: React.FC = () => {

  return (
    <AuthProvider>
      <GlobalLoading/>
      <Routes>
        <Route path="/subscription/result" element={<PrivateRoute><SubscriptionResultPage /></PrivateRoute>} />
        <Route path="/subscription/upgrade" element={<PrivateRoute><SubscriptionManagementPage /></PrivateRoute>} />
        <Route path="/unauthorized" element={<PrivateRoute><UnauthorizedPage /></PrivateRoute>} />
        <Route path="/not-found" element={<PrivateRoute><NotFoundPage /></PrivateRoute>} />
        <Route path="*" element={<PrivateRoute><NotFoundPage /></PrivateRoute>} />
      </Routes>
    </AuthProvider>
  );
};

export default AppRoutes;